import { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import "./style.scss";
import LocationFinder from "../locationFinder/index";
import MGA_API from "../../api/index";
import { useTranslation } from "react-i18next";
import { useAtom, useSetAtom } from "jotai";
import { loaderAtom } from "../../utils/atoms/loaderAtom";
import locationData from "./SAMPLE_LOCATION.json";
import { useNavigate } from "react-router-dom";
import { getRandomInt } from "../../Tarrif/TarifUtils";
import { locationAllDTOAtom } from "../../utils/atoms/locationAllDTOAtom";
import { activeTabAtom } from "../../utils/atoms/activeTabAtom";
import displayError from "../../constants/utils";

const MGAAPIS = new MGA_API();
const MGACreateProjectDialog = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [locationAllDTO] = useAtom(locationAllDTOAtom);
  const [locationDTO, setLocationData] = useState(locationAllDTO);
  const locationCallback = (data) => {
    setLocationData(data);
  };
  const { createProjectPopupStatus, closeCreateProjectModalHandler } = props;
  const [currencyList, setCurrencyList] = useState([]);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const setIsLoading = useSetAtom(loaderAtom);
  const [, setActiveState] = useAtom(activeTabAtom);

  const closeCreateProjectHandler = () => {
    closeCreateProjectModalHandler();
  };

  const createProjectModalHandler = () => {
    const validation = LocationFinder.validateLocation(
      locationDTO?.locationINData || locationAllDTO?.locationINData,
      locationDTO?.projectData?.projectName
        ? locationDTO?.projectData
        : locationAllDTO?.projectData,locationAllDTO?.projectData
    );

    if (validation) {
      displayError("error", "Please resolve errors before proceeding.");
      setShowErrorMsg(true);
    } else {
      setIsLoading(true);
      const locationDTODetails = {
        locationId: 0,
        address: locationDTO.locationINData.address,
        city: locationDTO.locationINData.city,
        zipCode: locationDTO.locationINData.zipCode,
        state: locationDTO.locationINData.stateProvince,
        country: locationDTO.locationINData.country,
        latitude: locationDTO.locationINData.latitude,
        longitude: locationDTO.locationINData.longitude,
      };
      const payload = {
        projectName:
          locationDTO.projectData.projectName ||
          locationAllDTO.projectData.projectName,
        projectNumber: `0001${getRandomInt(21, 9999)}`,
        customerName:
          locationDTO.projectData.customerName ||
          locationAllDTO.projectData.customerName,
        projectDescription:
          locationDTO.projectData.projectDescription ||
          locationAllDTO.projectData.projectDescription,
        currency:
          locationDTO.projectData.currency ||
          locationAllDTO.projectData.currency,
        currencyCode:
          locationDTO?.projectData?.currencyCode ||
          locationAllDTO.projectData.currencyCode,
        dateFormat:
          locationDTO?.projectData?.dateFormat ||
          locationAllDTO.projectData.dateFormat,
        numberFormat:
          locationDTO?.projectData?.numberFormat ||
          locationAllDTO.projectData.numberFormat,
        projectType: "ANSI",
        locationDTO: locationDTODetails,
        projectStatus: "INPROGRESS",
      };
      MGAAPIS.createProject(payload)
        .then((createRes) => {
          MGAAPIS.getProjects().then((projectsRes) => {
            props.state(projectsRes);
            setIsLoading(false);
            closeCreateProjectModalHandler();
            setActiveState("DESIGN");
            const createdProject = projectsRes?.find(p => p.projectId === createRes?.projectId);
            const designId = createdProject?.designWithVersionsDTOList?.[0]?.designDTO?.designId;
            const designVersionId = createdProject?.designWithVersionsDTOList?.[0]?.designVersionDTO?.[0]?.designVersionId;
            if (designId && designVersionId) {
              navigate(`/assessment/${createRes?.projectId}/${designId}/${designVersionId}?tab=design`);
            } 
          }).catch(() => {
            setIsLoading(false);
            closeCreateProjectModalHandler();
          });
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error fetching data:", error);
        });
    }
  };

  const getCurrencyList = () => {
    MGAAPIS.getDefaultInfo()
      .then((json) => {
        json.sort((a, b) => a.status.localeCompare(b.status));
        setCurrencyList(json);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getCurrencyList();
    const dialogElement = document.querySelector("se-dialog");
    const shadowRoot = dialogElement?.shadowRoot;

    if (dialogElement) {
      if (shadowRoot) {
        const dialog = shadowRoot.querySelector(".dialog");
        const innerDialog = shadowRoot.querySelector(".dialog-body-inner");
        if (dialog) {
          dialog.style.width = "90%"; // Adjust the width as needed
        }
        if (innerDialog) {
          dialog.style.height = "115vh";
        }
      }
    }

    // Set up MutationObserver to watch for changes in the shadow DOM
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          const dialog = shadowRoot.querySelector(".dialog");
          if (dialog) {
            dialog.style.width = "90%"; // Adjust the width as needed
          }
          const innerDialog = shadowRoot.querySelector(".dialog-body-inner");
          if (innerDialog) {
            innerDialog.style.maxHeight = "115vh";
          }
        }
      }
    });

    // Start observing the shadow DOM for changes
    if (shadowRoot) {
      observer.observe(shadowRoot, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    // Clean up the observer when the component unmounts
    return () => {
      observer.disconnect();
    };
  }, [createProjectPopupStatus]);

  useLayoutEffect(() => {});
  const LANGUAGE = "en";
  const CUSTOM_LABELS = LocationFinder.getLabelsForLanguage(LANGUAGE);

  return (
    <>
      <se-dialog
        class="mg-dialog"
        size="xlarge"
        open={createProjectPopupStatus}
        can-backdrop="false"
      >
        <se-dialog-header>
          <span className="se-dialog-custom-header project-modal-title">
            {t("createProject")}
          </span>
        </se-dialog-header>
        <se-dialog-content>
          <div className="row">
            <div className="col-sm-12">
              <LocationFinder
                locationData={locationData}
                locationDataCallback={locationCallback}
                mandatoryMsgDisplay={showErrorMsg}
                customLabels={CUSTOM_LABELS}
                currencyList={currencyList}
              />
            </div>
          </div>
        </se-dialog-content>
        <se-dialog-footer>
          <se-button
            aria-label="create-project-confirm"
            option="raised"
            color="primary"
            onClick={createProjectModalHandler}
            disabled={false}
          >
            {t("project.create.confirm")}
          </se-button>
          <se-button aria-label="create-project-cancel" option="outline" onClick={closeCreateProjectHandler}>
            {t("common.cancel")}
          </se-button>
        </se-dialog-footer>
      </se-dialog>

      <se-snackbar
        id="snackbar2"
        icon="information_stroke"
        canClose={true}
      ></se-snackbar>
    </>
  );
};
export default MGACreateProjectDialog;
